import { genericChartColours } from '@risksmart-app/components/src/utils/colours';
import { useCallback } from 'react';
import { z } from 'zod';

import { useGetColourPalettes } from './queries/colour-palette/useGetColourPalettes';

const colourPaletteSettingsSchema = z.object({
  colours: z.array(z.string()),
});

export const getPaletteColours = (settings: unknown): string[] =>
  colourPaletteSettingsSchema.safeParse(settings).data?.colours ??
  genericChartColours;

export const useColourPalette = () => {
  const { data, loading, error, refetch } = useGetColourPalettes({
    queryArgs: {},
  });

  let colours = genericChartColours;
  let paletteId;

  if (
    !loading &&
    !error &&
    data?.colour_palette &&
    data.colour_palette.length > 0
  ) {
    colours = getPaletteColours(data.colour_palette[0].Settings);
    paletteId = data.colour_palette[0].Id;
  }

  const genericCategoricalPalette = useCallback(
    (index: number) => {
      return colours.length > 0
        ? colours[index % colours.length]
        : genericChartColours[index % genericChartColours.length];
    },
    [colours]
  );

  return {
    loading,
    error,
    refetch,
    colours,
    paletteId,
    genericCategoricalPalette,
  };
};
